import IEcharts from './full.vue';

export default IEcharts;



// WEBPACK FOOTER //
// ./node_modules/vue-echarts-v3/src/full.js